import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import moment from "moment";
import {
    DialogTitle,
    Dialog,
    DialogContent,
    TextField,
    DialogActions,
    Typography,
    Grid
} from "@material-ui/core";
const formatDate = date => moment(date).format("MM-DD-YYYY");
const useStyles = makeStyles(theme => ({
    textField: { margin: theme.spacing(1) },
    button: {
        color: "white",
        background: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    commentBoxCont: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    gridElLeft: {
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
        },
      },
      hoursPadding:{
        paddingTop: "19px",
    },
      gridElRight: {
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'right',
        },
      },
    commentBox: {
        marginTop: theme.spacing(2),
    },
    dropdown: {
        margin: theme.spacing(1),
    },
    status: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: 10,
    },
    dialogTitle: {},
}));

const PtoReviewDialog = props => {
    const classes = useStyles();
    const {
        onClose,
        open,
        getManagerComment,
        dialogObj,
        handleApprove,
        handleDeny,
        handleDelete,
    } = props;

    const handleClose = () => onClose();
    const handleManagerComment = e => getManagerComment(e.target.value);

    const renderDeleteButton = () => {
        const { requestStatus } = dialogObj;
        if (requestStatus === "Pending") {
            return (
                <Button className={classes.button} onClick={handleDelete}>
                    Delete
                </Button>
            );
        }
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
            className={classes.root}
        >
            <DialogTitle id="simple-dialog-title">
                <Typography variant="h5" className={classes.dialogTitle}>
                    {`${dialogObj.requestTitle}`}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <div style={{ margin: 0, padding: 0 }}>
                    <div>
                        <TextField
                            className={classes.textField}
                            fullWidth
                            readOnly
                            id="standard-basic"
                            label="Start Date"
                            value={dialogObj.start || ""}
                        />
                        <TextField
                            className={classes.textField}
                            fullWidth
                            readOnly
                            id="standard-basic"
                            label="End Date"
                            value={(dialogObj.end || "")==""?"":formatDate(dialogObj.end)}
                        />
                    </div>
                    <Grid container justify='center' alignItems='center' >
                        <Grid item xs={12} md={8} className={classes.gridElLeft}>
                    <TextField
                        className={classes.textField}
                        fullWidth
                        readOnly
                        id="standard-basic"
                        label="Type"
                        value={dialogObj.requestType || ""}
                    />
                    </Grid>
                    <Grid item xs={12} md={1} >
                                </Grid>
                    <Grid item xs={12} md={3} className={classes.gridElRight}>
                              
                              <TextField 
                              className={classes.hoursPadding} 
                                  placeholder="partial hours"
                                  readOnly
                                  value={dialogObj.partialHours || ""}
                                  id="partialHours"
                                  name="partialHours"
                                  required={false}>
                              </TextField>
                              </Grid>
                              </Grid>
                    <div className={classes.commentBoxCont}>
                        <TextField
                            className={classes.commentBox}
                            id="outlined-basic"
                            label={`My Comments`}
                            autoFocus
                            variant="outlined"
                            onChange={handleManagerComment}
                            value={dialogObj.managerComment || ""}
                        />
                        <TextField
                            className={classes.commentBox}
                            readOnly
                            id="outlined-basic"
                            label={`${dialogObj.usersName}s Comments`}
                            variant="outlined"
                            value={dialogObj.userComments}
                        />
                    </div>
                </div>
                <div className={classes.status}>
                    <b>Status:</b>
                    <p>{dialogObj.requestStatus}</p>
                </div>
            </DialogContent>
            <DialogActions style={{ margin: 20 }}>
                {renderDeleteButton()}
                <Button
                    className={classes.button}
                    onClick={() =>
                        handleDeny({
                            ...dialogObj,
                            requestStatus: "Declined",
                        })
                    }
                >
                    Deny
                </Button>
                <Button
                    className={classes.button}
                    onClick={() =>
                        handleApprove({
                            ...dialogObj,
                            requestStatus: "Approved",
                        })
                    }
                >
                    Approve
                </Button>
            </DialogActions>
        </Dialog>
    );
};

PtoReviewDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

export default PtoReviewDialog;
